import { render, staticRenderFns } from "./download-app-page.vue?vue&type=template&id=7099792e&scoped=true&"
import script from "./download-app-page.vue?vue&type=script&lang=js&"
export * from "./download-app-page.vue?vue&type=script&lang=js&"
import style0 from "./download-app-page.vue?vue&type=style&index=0&id=7099792e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7099792e",
  null
  
)

export default component.exports